    // Creature Level	XP	Suggested Role
    // Party Level -4	10	Low-threat lackey
    // Party Level -3	15	Low- or moderate-threat lackey
    // Party Level -2	20	Any lackey or standard creature
    // Party Level -1	30	Any standard creature
    // Party Level	    40	Any standard creature or low-threat boss
    // Party Level +1	60	Low- or moderate-threat boss
    // Party Level +2	80	Moderate- or severe-threat boss
    // Party Level +3	120	Severe- or extreme-threat boss
    // Party Level +4	160	Extreme-threat solo boss

    export const MonsterXP = {'-4': 10, '-3': 15, '-2': 20, '-1': 30, '0': 40, '1': 60, '2': 80, '3': 120, '4': 160}